// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Account page — profile, plan, referral ─────────────────────────────── */

*, *::before, *::after { box-sizing: border-box; }

.acct-root {
  min-height: 100vh;
  width: 100%;
  background: #0b080c;
  font-family: inherit;
}

/* ── Navbar ──────────────────────────────────────────────────────────────── */

.acct-nav {
  padding: 22px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.acct-logo {
  font-size: 17px;
  font-weight: 800;
  letter-spacing: -0.2px;
  color: rgba(240, 236, 230, 0.55);
}

.acct-nav-right {
  display: flex;
  align-items: center;
  gap: 22px;
}

.acct-nav-link,
.acct-logout {
  background: none;
  border: none;
  font-size: 13px;
  color: rgba(240, 236, 230, 0.45);
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}

.acct-nav-link:hover,
.acct-logout:hover {
  color: rgba(240, 236, 230, 0.85);
}

/* ── Main ────────────────────────────────────────────────────────────────── */

.acct-main {
  max-width: 560px;
  margin: 0 auto;
  padding: 40px 32px 80px;
}

.acct-title {
  margin: 0 0 28px;
  font-size: 28px;
  font-weight: 700;
  color: #f0ece6;
}

.acct-card {
  padding: 26px 28px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  margin-bottom: 24px;
}

.acct-card-title {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 700;
  color: #f0ece6;
}

.acct-profile-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.acct-profile-row:last-of-type {
  border-bottom: none;
}

.acct-profile-label {
  font-size: 13px;
  color: #8a8480;
}

.acct-profile-value {
  font-size: 14px;
  font-weight: 600;
  color: #f0ece6;
}

.acct-plan-badge {
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #cfc8c2;
}

.acct-plan-badge--premium {
  background: rgba(212, 175, 55, 0.15);
  color: #d4af37;
}

.acct-subscribe-btn {
  display: block;
  width: 100%;
  margin-top: 18px;
  padding: 13px;
  background: #f0ece6;
  color: #0b080c;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s ease;
}

.acct-subscribe-btn:hover {
  background: #ffffff;
}

/* ── Referral ────────────────────────────────────────────────────────────── */

.acct-clicks {
  margin: 0 0 16px 0;
  font-size: 13px;
  color: #cfc8c2;
}

.acct-clicks strong {
  color: #f0ece6;
}

.acct-card-desc {
  margin: 0 0 16px 0;
  font-size: 12.5px;
  color: #8a8480;
  line-height: 1.5;
}

.acct-referral-link-row {
  display: flex;
  gap: 8px;
}

.acct-referral-input {
  flex: 1 1;
  padding: 10px 12px;
  background: #0b080c;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #cfc8c2;
  font-size: 12.5px;
}

.acct-referral-copy {
  padding: 10px 16px;
  background: #f0ece6;
  color: #0b080c;
  border: none;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.acct-referral-copy:hover {
  background: #ffffff;
}

/* ── Responsive ──────────────────────────────────────────────────────────── */

@media (max-width: 600px) {
  .acct-nav { padding: 18px 24px; }
  .acct-main { padding: 32px 20px 60px; }
  .acct-card { padding: 22px 20px; }
}

/* ── Go-back button ───────────────────────────────────────────────────── */
.acct-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  margin-bottom: 14px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: transparent;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.15s ease;
}
.acct-back-btn:hover {
  border-color: #c084fc;
  color: #c084fc;
  transform: translateX(-2px);
}
`, "",{"version":3,"sources":["webpack://./src/components/Account.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,YAAY,kBAAkB,EAAE;EAChC,aAAa,uBAAuB,EAAE;EACtC,aAAa,kBAAkB,EAAE;AACnC;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B","sourcesContent":["/* ── Account page — profile, plan, referral ─────────────────────────────── */\n\n*, *::before, *::after { box-sizing: border-box; }\n\n.acct-root {\n  min-height: 100vh;\n  width: 100%;\n  background: #0b080c;\n  font-family: inherit;\n}\n\n/* ── Navbar ──────────────────────────────────────────────────────────────── */\n\n.acct-nav {\n  padding: 22px 48px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.acct-logo {\n  font-size: 17px;\n  font-weight: 800;\n  letter-spacing: -0.2px;\n  color: rgba(240, 236, 230, 0.55);\n}\n\n.acct-nav-right {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n}\n\n.acct-nav-link,\n.acct-logout {\n  background: none;\n  border: none;\n  font-size: 13px;\n  color: rgba(240, 236, 230, 0.45);\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.2s;\n}\n\n.acct-nav-link:hover,\n.acct-logout:hover {\n  color: rgba(240, 236, 230, 0.85);\n}\n\n/* ── Main ────────────────────────────────────────────────────────────────── */\n\n.acct-main {\n  max-width: 560px;\n  margin: 0 auto;\n  padding: 40px 32px 80px;\n}\n\n.acct-title {\n  margin: 0 0 28px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #f0ece6;\n}\n\n.acct-card {\n  padding: 26px 28px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  margin-bottom: 24px;\n}\n\n.acct-card-title {\n  margin: 0 0 16px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #f0ece6;\n}\n\n.acct-profile-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.acct-profile-row:last-of-type {\n  border-bottom: none;\n}\n\n.acct-profile-label {\n  font-size: 13px;\n  color: #8a8480;\n}\n\n.acct-profile-value {\n  font-size: 14px;\n  font-weight: 600;\n  color: #f0ece6;\n}\n\n.acct-plan-badge {\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #cfc8c2;\n}\n\n.acct-plan-badge--premium {\n  background: rgba(212, 175, 55, 0.15);\n  color: #d4af37;\n}\n\n.acct-subscribe-btn {\n  display: block;\n  width: 100%;\n  margin-top: 18px;\n  padding: 13px;\n  background: #f0ece6;\n  color: #0b080c;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n\n.acct-subscribe-btn:hover {\n  background: #ffffff;\n}\n\n/* ── Referral ────────────────────────────────────────────────────────────── */\n\n.acct-clicks {\n  margin: 0 0 16px 0;\n  font-size: 13px;\n  color: #cfc8c2;\n}\n\n.acct-clicks strong {\n  color: #f0ece6;\n}\n\n.acct-card-desc {\n  margin: 0 0 16px 0;\n  font-size: 12.5px;\n  color: #8a8480;\n  line-height: 1.5;\n}\n\n.acct-referral-link-row {\n  display: flex;\n  gap: 8px;\n}\n\n.acct-referral-input {\n  flex: 1;\n  padding: 10px 12px;\n  background: #0b080c;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #cfc8c2;\n  font-size: 12.5px;\n}\n\n.acct-referral-copy {\n  padding: 10px 16px;\n  background: #f0ece6;\n  color: #0b080c;\n  border: none;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.acct-referral-copy:hover {\n  background: #ffffff;\n}\n\n/* ── Responsive ──────────────────────────────────────────────────────────── */\n\n@media (max-width: 600px) {\n  .acct-nav { padding: 18px 24px; }\n  .acct-main { padding: 32px 20px 60px; }\n  .acct-card { padding: 22px 20px; }\n}\n\n/* ── Go-back button ───────────────────────────────────────────────────── */\n.acct-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  margin-bottom: 14px;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: transparent;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.acct-back-btn:hover {\n  border-color: #c084fc;\n  color: #c084fc;\n  transform: translateX(-2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
